import { render } from "./DeleteDocumentModal.vue?vue&type=template&id=35ae6ec0"
import script from "./DeleteDocumentModal.vue?vue&type=script&lang=js"
export * from "./DeleteDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__